import { createSelector } from 'reselect';

import { NOTIFICATION_ACTIONS } from '../constants/NotificationConstants';

export const getNotifications = (state) => state.notifications;

export const getUnreadNotificationsCount = createSelector(
  getNotifications,
  (notifications) =>
    notifications.filter((notification) => notification.action === NOTIFICATION_ACTIONS.UNREAD)
      .length
);
